import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import GitHubButton from 'react-github-btn';
import Gallery from './gallery/Gallery.tsx';
import VersionTable from './components/VersionTable.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "encodable"
    }}>{`Encodable`}</h1>
    <p><a parentName="p" {...{
        "href": "https://codecov.io/gh/kristw/encodable/branch/master"
      }}><img alt="Codecov branch" src="https://img.shields.io/codecov/c/github/kristw/encodable/master.svg?style=flat-square" /></a>{`
`}<img alt="GitHub Workflow Status" src="https://img.shields.io/github/workflow/status/kristw/encodable/build-and-test-workflow?style=flat-square" />{`
`}<a parentName="p" {...{
        "href": "https://david-dm.org/kristw/encodable?type=dev"
      }}><img alt="David" src="https://img.shields.io/david/dev/kristw/encodable.svg?style=flat-square" /></a></p>

    <div style={{
      marginBottom: 16,
      marginTop: -20
    }}>
  <GitHubButton href="https://github.com/kristw/encodable" data-icon="octicon-star" data-size="large" data-show-count="true" aria-label="Star Encodable on GitHub" mdxType="GitHubButton">Star</GitHubButton>
    </div>
    <p>{`For an author of a visualization component, this library helps you defines the visual
channels that you can encode data into and provide API similar to `}<inlineCode parentName="p">{`vega-lite`}</inlineCode>{`'s grammar for
component users to customize the visual encoding.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install encodable global-box
`}</code></pre>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>

    <div style={{
      marginBottom: 16
    }}>
  <Gallery count={4} mdxType="Gallery" />
    </div>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/encodable-demo-wvhj3?fontsize=14&hidenavigation=1&theme=dark"
      }}><img alt="Edit encodable Demo" src="https://codesandbox.io/static/img/play-codesandbox.svg" /></a></p>
    <h2 {...{
      "id": "packages"
    }}>{`Packages`}</h2>
    <p>{`The main `}<inlineCode parentName="p">{`npm`}</inlineCode>{` package is `}<inlineCode parentName="p">{`encodable`}</inlineCode>{`, which uses a few micro-packages under the hood.
These micro-packages are useful by themselves beyond the context of `}<inlineCode parentName="p">{`encodable`}</inlineCode>{` and can be adopted in other projects.`}</p>

    <VersionTable packages={[{
      name: 'encodable',
      codePath: 'packages/encodable',
      docPath: '/intro'
    }, {
      name: '@encodable/color',
      codePath: 'packages/encodable-color',
      docPath: '/encodable-color'
    }, {
      name: '@encodable/dimension',
      codePath: 'packages/encodable-dimension',
      docPath: '/encodable-dimension'
    }, {
      name: '@encodable/format',
      codePath: 'packages/encodable-format',
      docPath: '/encodable-format'
    }, {
      name: '@encodable/registry',
      codePath: 'packages/encodable-registry',
      docPath: '/encodable-registry'
    }]} mdxType="VersionTable" />
    <h2 {...{
      "id": "publication"
    }}>{`Publication`}</h2>
    <p>{`The pre-print version of the paper is publicly available and can be found `}<a parentName="p" {...{
        "href": "https://arxiv.org/abs/2009.00722"
      }}>{`here`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`K. Wongsuphasawat, "Encodable: Configurable Grammar for Visualization Components",
To appear in Proceedings of the 2020 IEEE Visualization Conference (VIS), 2020.`}</p>
    </blockquote>
    <p>{`or bibtex`}</p>
    <pre><code parentName="pre" {...{}}>{`@INPROCEEDINGS{encodable_vis,
  author={Krist Wongsuphasawat},
  booktitle={2020 IEEE Visualization Conference (VIS)},
  title={Encodable: Configurable Grammar for Visualization Components},
  year={2020},
  volume={},
  number={},
  note="To appear"}
`}</code></pre>
    <h2 {...{
      "id": "license"
    }}>{`License`}</h2>
    <p>{`Apache-2.0`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      